import React from 'react';
import { Box, Heading, Text, SimpleGrid, Stat, StatLabel, StatNumber, StatHelpText } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const UserDashboard = () => {
  const { user } = useSelector((state) => state.auth);

  return (
    <Box p={4}>
      <Heading mb={4}>Dashboard</Heading>
      <Text mb={6}>Welcome, {user?.name}</Text>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {/* User Stats */}
        <Stat
          px={4}
          py={5}
          shadow="xl"
          border="1px solid"
          borderColor="gray.200"
          rounded="lg"
        >
          <StatLabel>Status</StatLabel>
          <StatNumber>{user?.isClub ? 'Club Account' : 'User Account'}</StatNumber>
          <StatHelpText>Active</StatHelpText>
        </Stat>

        {/* Club-specific stats if user is a club */}
        {user?.isClub && user?.clubDetails && (
          <>
            <Stat
              px={4}
              py={5}
              shadow="xl"
              border="1px solid"
              borderColor="gray.200"
              rounded="lg"
            >
              <StatLabel>Club Name</StatLabel>
              <StatNumber>{user.clubDetails.name}</StatNumber>
              <StatHelpText>Club Status: {user.clubDetails.status}</StatHelpText>
            </Stat>

            <Stat
              px={4}
              py={5}
              shadow="xl"
              border="1px solid"
              borderColor="gray.200"
              rounded="lg"
            >
              <StatLabel>Members</StatLabel>
              <StatNumber>{user.clubDetails.memberCount}</StatNumber>
              <StatHelpText>Total Members</StatHelpText>
            </Stat>
          </>
        )}
      </SimpleGrid>
    </Box>
  );
};

export default UserDashboard;
